import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Picker from '@emoji-mart/react';
import AppContext, { ChatContext } from 'context/Context';
import { getColor } from 'helpers/utils';
import TextareaAutosize from 'react-textarea-autosize';

const MessageTextArea = () => {
  const {
    sendMessage,
    readMessages,
    conversation,
    getConversations,
    setScrollToBottom
  } = useContext(ChatContext);

  const [message, setMessage] = useState('');

  const {
    config: { isDark, isRTL }
  } = useContext(AppContext);

  const addEmoji = e => {
    let emoji = e.native;
    setMessage(message + emoji);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (message && conversation) {
      await sendMessage({
        conversationId: conversation.id,
        message
      });
      await readMessages(conversation.id);

      await getConversations();
    }
    setMessage('');
    setScrollToBottom(true);
  };

  return (
    <Form className="chat-editor-area" onSubmit={handleSubmit}>
      <TextareaAutosize
        minRows={1}
        maxRows={6}
        value={message}
        placeholder="Escribe un mensaje..."
        onChange={({ target }) => setMessage(target.value)}
        disabled={!conversation}
        onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            handleSubmit(e);
          }
        }}
        className="form-control outline-none resize-none rounded-0 border-0 emojiarea-editor"
      />

      {/* <Form.Group controlId="chatFileUpload">
        <Form.Label className="chat-file-upload cursor-pointer">
          <FontAwesomeIcon icon="paperclip" />
        </Form.Label>
        <Form.Control type="file" className="d-none" />
      </Form.Group> */}

      <Dropdown>
        <Dropdown.Toggle variant="link" className="emoji-icon">
          <FontAwesomeIcon icon={['far', 'laugh-beam']} />
        </Dropdown.Toggle>

        <Dropdown.Menu className="py-0">
          <Picker
            set="google"
            onEmojiSelect={addEmoji}
            sheetSize={20}
            style={{
              bottom: '2rem',
              left: isRTL ? '2%' : 'auto',
              right: isRTL ? 'auto' : '2%',
              padding: 0,
              zIndex: 1,
              backgroundColor: getColor('100')
            }}
            theme={isDark ? 'dark' : 'light'}
            showPreview={false}
            showSkinTones={false}
            locale="es"
            maxFrequentRows={0}
            previewPosition="none"
            perLine={7}
            emojiSize={30}
          />
        </Dropdown.Menu>
      </Dropdown>

      <Button
        variant="send"
        size="sm"
        className={classNames({
          'text-primary': message.length > 0,
          'border-0 shadow-none': true
        })}
        type="submit"
      >
        Enviar
      </Button>
    </Form>
  );
};

MessageTextArea.propTypes = {
  thread: PropTypes.object
};

export default MessageTextArea;
